var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"mc-selectbox-pane"},[_c('ul',[_vm._t("default")],2),_vm._v(" "),_vm._t("footer")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-selectbox-pane.vue